import { Card, BlockStack, Text, Divider, Banner } from '@shopify/polaris';
import { IAiConnection } from '@/types/aiAssistants';
import { AI_STRINGS, PROVIDERS_MANUAL, ProviderBrand } from '../../config';
import ClaudeRow from './ClaudeRow';
import ProviderRow from './ProviderRow';

interface IProviderHubCardProps {
  claudeConnection: IAiConnection | null;
  claudeError: boolean;
  isClaudeLoading: boolean;
  onClaudeRetry: () => void;
  onClaudeConnect: () => void;
  onClaudeDisconnect: () => void;
  onOpenHowTo: (provider: ProviderBrand) => void;
}

const ProviderHubCard = (props: IProviderHubCardProps) => (
  <Card>
    <BlockStack gap="400">
      <Text as="h3" variant="headingMd">
        AI Assistants
      </Text>

      {props.claudeError ? (
        <Banner tone="critical" action={{ content: 'Retry', onAction: props.onClaudeRetry }}>
          <p>{AI_STRINGS.ERROR_LOAD_FAILED}</p>
        </Banner>
      ) : (
        <ClaudeRow
          connection={props.claudeConnection}
          isLoading={props.isClaudeLoading}
          onConnect={props.onClaudeConnect}
          onDisconnect={props.onClaudeDisconnect}
        />
      )}

      {PROVIDERS_MANUAL.map((p) => (
        <BlockStack key={p.key} gap="400">
          <Divider />
          <ProviderRow provider={p} onHowToConnect={() => props.onOpenHowTo(p.key)} />
        </BlockStack>
      ))}
    </BlockStack>
  </Card>
);

export default ProviderHubCard;
